import { usePostClientLogsHook } from "api-client";

type LoggerProps = {
  log?: string;
  errorType?: string;
  errorCode?: string;
  errorMessage?: string;
};

export const useLogger = () => {
  const postClientLogs = usePostClientLogsHook();

  return ({ log, errorType, errorCode, errorMessage }: LoggerProps) => {
    console.log(`${log} ${errorCode} ${errorType} ${errorMessage}`);

    postClientLogs({
      timestamp: new Date().toISOString(),
      level: "ERROR",
      message: log ?? "",
      metadata: {
        errorType,
        errorCode,
        errorMessage,
      },
    } as any);
  };
};
